import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const VoidLineItemModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "VoidLineItemModalContainer" */
      './VoidLineItemModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
